module.exports = __webpack_public_path__ + "static/img/61-2.9dd6939.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/61-2.jpg
// module id = ImHL
// module chunks = 0